import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';

import { ManageAssetListModalComponent } from '../../../shared/components/manage-asset-list-modal/manage-asset-list-modal.component';
import { AssetExportModalComponent } from '../../../shared/components/asset-export-modal/asset-export-modal.component';

@Injectable({
  providedIn: 'root',
})
export class AssetListModalService {
  constructor(private readonly modalService: NgbModal) {}

  public openExportModal(assets: any[], campaignId: string): void {
    const exportModal: any = this.modalService.open(AssetExportModalComponent, {
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
      modalDialogClass: 'responsive-modal',
    });

    exportModal.componentInstance.assets = assets;
    exportModal.componentInstance.campaignId = campaignId;
  }

  public openManageAssetModelsModal(
    assets: any[],
    campaignId: string,
    unSubscribeOnDestroy: any,
    onModelExported: () => void,
    onRefetchRawAssets: () => void
  ): void {
    const manageAssetModelsModal: any = this.modalService.open(ManageAssetListModalComponent, {
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
      modalDialogClass: 'responsive-modal',
    });

    manageAssetModelsModal.componentInstance.rawAssets = assets;
    manageAssetModelsModal.componentInstance.campaignId = campaignId;

    manageAssetModelsModal.componentInstance.modelExported.pipe(takeUntil(unSubscribeOnDestroy)).subscribe(() => {
      onModelExported();
    });

    manageAssetModelsModal.componentInstance.refetchRawAssets.pipe(takeUntil(unSubscribeOnDestroy)).subscribe(() => {
      onRefetchRawAssets();
    });
  }
}
